import React, { useEffect } from 'react';
import { Box, Button, Icon, LayoutContent, LayoutControls, Typography, } from '@pinwheel/origami';
import { useGetLocalizedString } from '../hooks/useGetLocalizedString';
import { useOpts } from '../context';
import useIntro from '../hooks/useIntro';
import { ScreenTitleHeader } from './ScreenTitleHeader';
import TermsOfService, { TermsOfServiceTextVariant } from '../TermsOfService';
var IntroRowCopyWithHeaderAndBody = function (props) { return (React.createElement("li", { className: "introFeature" },
    React.createElement(Box, { sx: {
            display: 'flex',
            flexDirection: 'row',
        } },
        React.createElement(Box, { sx: {
                width: '40px',
                minWidth: '40px',
            } },
            React.createElement(Icon, { icon: props.icon, className: "introFeature__icon", size: props.iconSize, color: props.iconColor })),
        React.createElement(Box, null,
            React.createElement("div", { className: "introFeature__header", style: { marginBottom: '4px' } },
                React.createElement(Typography, { variant: "header", as: "h3", color: props.textColor, sx: {
                        fontFamily: 'FiraSans',
                        fontSize: '16px',
                        fontWeight: 600,
                    } }, props.header)),
            React.createElement("div", null, props.body.map(function (b, i) {
                return (React.createElement(Typography, { variant: "body", color: "default", key: i, sx: {
                        fontFamily: 'FiraSans',
                        fontSize: '16px',
                        fontWeight: 400,
                        color: {
                            type: 'raw',
                            colorPair: {
                                light: '#373535',
                                dark: '#373535',
                            },
                        },
                        lineHeight: '1.4',
                    } }, b));
            })))))); };
export function CitizensIntroContent(_a) {
    var onContinue = _a.onContinue;
    var getLocalizedString = useGetLocalizedString();
    var fireClientEvent = useOpts().fireClientEvent;
    useEffect(function () {
        fireClientEvent('input_required');
    }, [fireClientEvent]);
    var _b = useIntro(), title = _b.title, headerTextColor = _b.headerTextColor, iconColor = _b.iconColor, rows = _b.rows;
    return (React.createElement(React.Fragment, null,
        React.createElement(LayoutContent, { className: "introContent" },
            React.createElement("div", null,
                React.createElement("div", { className: "introFeatures" },
                    React.createElement(ScreenTitleHeader, { sx: {
                            fontFamily: 'FiraSans',
                            fontSize: '32px',
                            fontWeight: 600,
                            marginBottom: '24px',
                        }, variant: "marquee", "data-testid": "introTitle", as: "h2", color: headerTextColor }, title),
                    React.createElement("ul", { style: {
                            padding: 0,
                        } }, rows.map(function (_a, i) {
                        var icon = _a.icon, iconSize = _a.iconSize, header = _a.header, body = _a.body;
                        return (React.createElement(IntroRowCopyWithHeaderAndBody, { key: i, header: header, body: body, iconColor: iconColor, icon: icon, iconSize: iconSize, textColor: headerTextColor }));
                    }))))),
        React.createElement(LayoutControls, null,
            React.createElement(TermsOfService, { textVariant: TermsOfServiceTextVariant.GET_STARTED_BUTTON, textColor: {
                    type: 'raw',
                    colorPair: {
                        light: '#373535',
                        dark: '#373535',
                    },
                } }),
            React.createElement(Button, { dataTestId: "button", "aria-label": "Continue", eventId: "IntroScreen-continue", onClick: onContinue }, getLocalizedString('GET_STARTED')))));
}
